import axios from './Api';

export function UploadImportFile(data = new FormData(), options: Axios.IOptions = {}) {
  return axios.post<BillAids.IUploadImportFile>('/billaids/import', data, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: options.onUploadProgress
  });
}

export function GetImportStatus() {
  return axios.get<BillAids.IImportStatus>('/billaids/import/status');
}

export function ListImportFiles() {
  return axios.get<BillAids.IListImportFile[]>('/billaids/import/list');
}

export function AproveImport(id = 0) {
  return axios.get<BillAids.IAproveImport>(`/billaids/import/${id}/validateForAdmin`);
}

export function FinalizeImport(ids: Array<string | number>) {
  return axios.post<BillAids.IAproveImport>(`/billaids/import/validateForAll`, { aidBillImports: ids.join(',') });
}

export function GetImportErrorFile(id = 0) {
  return axios.get<BillAids.IImportErrorFile>(`/billaids/import/${id}/errorFile`, { responseType: 'blob' });
}

export function DeleteImport(id = 0) {
  return axios.delete(`/billaids/import/${id}`);
}

export function CalculatePayments(data: BillAids.ICalculateData) {
  return axios.post<BillAids.ICalculateResponse>('/billaids/billed/calculate', data);
}

export function DownloadDocument(data: BillAids.IDownloadData) {
  return axios.post<BillAids.IDownloadResponse>('/billaids/billed/export', data, { responseType: 'blob' });
}

export function HistorySearch(cnp = '') {
  return axios.post<BillAids.IBillAidsHistoryResponse[]>('/billaids/billed/search', { cnp });
}
